import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiClientService, IObavjestenje } from '../../services/api-client.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-obavjestenja',
  templateUrl: './obavjestenja.component.html',
  styleUrls: ['./obavjestenja.component.scss']
})
export class ObavjestenjaComponent {
  @ViewChild('obavjestenjaGrid', { static: false }) obavjestenjaGrid: any;

  gridData: IObavjestenje[] = [];
  loading = false;
  isEditPopupVisible = false;
  isCreatePopupVisible = false;
  selectedObavjestenje: IObavjestenje | null = null;
  loadPanelPosition = { of: '#obavjestenjaGrid' };

  obavjestenjeForm!: FormGroup;

  constructor(
    private apiClient: ApiClientService,
    private fb: FormBuilder,
    private userService: UserService
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.loadObavjestenja();
  }

  initializeForm() {
    this.obavjestenjeForm = this.fb.group({
      tekst: ['', Validators.required]
    });
  }

  async loadObavjestenja() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.obavjestenjaAll();
    } catch (error) {
      console.error('Error loading obavjestenja:', error);
    } finally {
      this.loading = false;
    }
  }

  onObavjestenjeRowClick(e: any) {
    if (e.data) {
      this.selectedObavjestenje = e.data;
    }
  }

  onAddClick() {
    this.selectedObavjestenje = null;
    this.obavjestenjeForm.reset();
    this.isCreatePopupVisible = true;
  }

  onEditClick() {
    if (this.selectedObavjestenje) {
      this.populateForm(this.selectedObavjestenje);
      this.isEditPopupVisible = true;
    }
  }

  onDeleteClick() {
    if (this.selectedObavjestenje && confirm('Da li ste sigurni da želite obrisati ovo obavještenje?')) {
      this.deleteObavjestenje(this.selectedObavjestenje.id as number);
    }
  }

  populateForm(obavjestenje: IObavjestenje) {
    this.obavjestenjeForm.patchValue({
      tekst: obavjestenje.tekst
    });
  }

  async createObavjestenje() {
    if (this.obavjestenjeForm.valid) {
      this.loading = true;
      try {
        const formData = this.obavjestenjeForm.value;
        await this.apiClient.obavjestenjaPOST(formData);
        this.isCreatePopupVisible = false;
        this.obavjestenjeForm.reset();
        this.loadObavjestenja(); // Refresh grid
      } catch (error) {
        console.error('Error creating obavjestenje:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  async updateObavjestenje() {
    if (this.obavjestenjeForm.valid && this.selectedObavjestenje) {
      this.loading = true;
      try {
        const formData = this.obavjestenjeForm.value;
        formData.id = this.selectedObavjestenje.id;
        await this.apiClient.obavjestenjaPUT(this.selectedObavjestenje.id as number, formData);
        this.isEditPopupVisible = false;
        this.loadObavjestenja(); // Refresh grid
      } catch (error) {
        console.error('Error updating obavjestenje:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  async deleteObavjestenje(id: number) {
    this.loading = true;
    try {
      await this.apiClient.obavjestenjaDELETE(id);
      this.selectedObavjestenje = null;
      this.loadObavjestenja(); // Refresh grid
    } catch (error) {
      console.error('Error deleting obavjestenje:', error);
    } finally {
      this.loading = false;
    }
  }

  onRefreshClick() {
    this.loadObavjestenja();
  }

  onEditPopupHidden() {
    this.isEditPopupVisible = false;
    this.selectedObavjestenje = null;
  }

  onCreatePopupHidden() {
    this.isCreatePopupVisible = false;
  }

  public isUserAgroModerator(): boolean {
    return this.userService.isUserAgroModerator();
  }
}
